import type { FaireBrandEntity } from "../../entity_types/brand";

export const fineRawChocolate: FaireBrandEntity = {
  token: "fine-raw-chocolate",
  type: "brand",
  name: "Fine & Raw Chocolate",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/901677914a087daf37d3ba0d2491608f5c577da7df9c429056eae062d6ad59a1.webp",
  description: "Organic handmade chocolate from Brooklyn",
  rating: 4.9,
  location: "Brooklyn, NY",
  minimumOrderDollars: 100,
  tags: ["organic", "handmade", "chocolate"],
  isInsider: true,
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
